import { z } from "@/zod";
import {
  ulid,
  nonNegativeDecimalStringSchema,
  projectDependsOn,
  dateTime,
} from "@/schemas/commonFields";

export const invoiceSpecificationSchema = z.object({
  id: ulid,
  ref_number: z.coerce.number().nonnegative(),
  project_id: z.string(),
  project_ref_number: z.coerce.number().nonnegative(),
  project_name: z.string(),
  period_id: ulid,
  period: z.string().date(),
  invoicing_company_id: ulid,
  invoicing_company: z.string(),
  services_and_goods_id: ulid,
  services_and_goods: z.string(),
  services_and_goods_code: z.string(),
  services_and_goods_invoice_description: z.string(),
  primary_manager_id: ulid,
  primary_manager: z.string(),
  client_id: ulid,
  client: z.string(),
  client_code: z.string(),
  client_ref_number: z.string().nullable().optional(),
  client_tax_number: z.string().nullable().optional(),
  client_contact_invoice: z.string().nullable().optional(),
  code: z.string().optional(),
  issued_at: z.string().date(),
  po_number: z.string().optional(),
  comment: z.string().optional(),
  project_depends_on: projectDependsOn,
  created_at: dateTime,
  hours: nonNegativeDecimalStringSchema,
  contractors_work_income: nonNegativeDecimalStringSchema,
  additions: nonNegativeDecimalStringSchema,
  deductions: nonNegativeDecimalStringSchema,
  costs: nonNegativeDecimalStringSchema,
  income: nonNegativeDecimalStringSchema,
  deleted_at: dateTime.nullable(),
});

export const invoiceSpecificationRead = invoiceSpecificationSchema
  .omit({
    invoicing_company_id: true,
    services_and_goods_id: true,
    primary_manager_id: true,
    client_id: true,
  })
  .readonly();

export const invoiceSpecificationUpdateSchema = invoiceSpecificationSchema.pick(
  {
    issued_at: true,
    po_number: true,
    comment: true,
  },
);
